(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_packages-step-indicator"] && !Shopify.designMode) return;
  try {
    const urlParams = new URLSearchParams(window.location.search);
  const packageId = urlParams.get('packageId');
  const optionId = urlParams.get('optionId');
  const isPackage = !!packageId && !!optionId;

  if (isPackage) document.querySelector('.package-builder-header').style.display = 'flex';

  document.addEventListener('DOMContentLoaded', function () {
    const viewSummaryBtn = document.querySelector('[data-action="view-summary"]');

    if (viewSummaryBtn) {
      viewSummaryBtn.addEventListener('click', function () {
        // Dispatch custom event or trigger modal
        document.dispatchEvent(new CustomEvent('viewSummary'));
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
